/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from './_shared/navmenu/navmenu.component.ngfactory';
import * as i3 from '../../../ClientApp/app/_shared/navmenu/navmenu.component';
import * as i4 from '../../../ClientApp/app/_shared/services/msal.service';
import * as i5 from '../../../ClientApp/app/_shared/services/energy-data.service';
import * as i6 from '../../../ClientApp/app/_shared/services/globals';
import * as i7 from '@angular/router';
import * as i8 from '../../../ClientApp/app/app.component';
import * as i9 from '../../../ClientApp/app/_shared/services/monitoring.service';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),13,'div',[['class',
      'container-fluid']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),4,'div',[['class','row']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'nav-menu',([] as any[]),(null as any),
          (null as any),(null as any),i2.View_NavMenuComponent_0,i2.RenderType_NavMenuComponent)),
      i1.ɵdid(49152,(null as any),0,i3.NavMenuComponent,[i4.MsalService,i5.EnergyDataService,
          i6.Globals],(null as any),(null as any)),(_l()(),i1.ɵted((null as any),['            \n    '])),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          4,'div',[['class','row content']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(212992,(null as any),0,i7.RouterOutlet,[i7.ChildrenOutletContexts,i1.ViewContainerRef,
          i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵted((null as any),
          ['\n'])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    _ck(_v,11,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i1.ɵdid(114688,(null as any),0,i8.AppComponent,[i5.EnergyDataService,i9.MonitoringService],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i8.AppComponent> = i1.ɵccf('app',
    i8.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9DbGllbnRBcHAvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vYXBwL0NsaWVudEFwcC9hcHAvYXBwLmNvbXBvbmVudC50cyIsIm5nOi8vL2FwcC9DbGllbnRBcHAvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2FwcC9DbGllbnRBcHAvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz0nY29udGFpbmVyLWZsdWlkJz5cbiAgICA8ZGl2IGNsYXNzPSdyb3cnPlxuICAgICAgICA8bmF2LW1lbnU+PC9uYXYtbWVudT4gICAgICAgICAgICBcbiAgICA8L2Rpdj5cbiAgICA8ZGl2IGNsYXNzPVwicm93IGNvbnRlbnRcIj5cbiAgICAgICAgPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PlxuICAgIDwvZGl2PlxuPC9kaXY+XG4iLCI8YXBwPjwvYXBwPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUFBLGdCQUE2QiwyQ0FDekI7TUFBQTtNQUFBLDRDQUFpQjtNQUNiO1VBQUE7YUFBQTtvQkFBQSwrQkFBcUI7TUFDbkIsMkNBQ047VUFBQTtVQUFBLDhCQUF5QjtNQUNyQjtVQUFBO2FBQUE7c0NBQUE7VUFBQSxlQUErQiwyQ0FDN0I7VUFBQSxTQUNKO0lBRkU7Ozs7b0JDTFI7TUFBQTthQUFBO1VBQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./$$_gendir/ClientApp/app/app.component.ngfactory.ts